import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class VatRateUsedWithTechnicalZeroError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.fiscalization.validation.vat-rate-id.used-with-technical-zero');
    }
}
